import React from 'react'

import { useStrategyMemoId } from '../useStrategyMemoId'

export const useMainQueryKey = () => {
  const strategyMemoId = useStrategyMemoId()

  return React.useMemo(
    () => ['StrategyMemoEditPage_Main', { strategyMemoId }] as const,
    [strategyMemoId],
  )
}
